import axios from 'axios';

const currentUrl = window.location.href;
let BASE_URL = '';

if (currentUrl.includes("devari.com.br")) {
  BASE_URL = "https://rifa-api.devari.com.br/api/v1";
} else if (currentUrl.includes("devaribox.co")) {
  BASE_URL = "https://clickpromo-api.devaribox.co/api/v1";
} else if (currentUrl.includes(":300")) {
  BASE_URL = "https://rifa-api.devari.com.br/api/v1";
  // BASE_URL = "https://clickpromo-api.devaribox.co/api/v1";
  // BASE_URL = "http://192.168.1.3:3001/api/v1";
  // BASE_URL = "http://localhost:3001/api/v1";
}

const provider = axios.create({
  baseURL: BASE_URL,
});

export default provider;
